import {useDebugValue} from 'react';

import classNames from 'classnames';

import {hasFilledDates} from '../../../utils/dates';

const classNamespace = 'search-form';
const dateRangeDisplayClassName = `${classNamespace}__date-range-display`;

const dateRangeDisplayDateClassName = `${dateRangeDisplayClassName}-date`;
const dateRangeDisplayStartDateClassName = `${dateRangeDisplayDateClassName}--start`;
const dateRangeDisplayEndDateClassName = `${dateRangeDisplayDateClassName}--end`;

const dateRangeDisplaySeparatorClassName = `${dateRangeDisplayClassName}-separator`;

function useComponent(props) {
    const {
        locale,
        startLabel,
        endLabel,
        startDate,
        endDate,
        dateFormatOptions,
        isSelecting
    } = props;

    const className = classNames(dateRangeDisplayClassName);

    const startDateClassName = classNames(dateRangeDisplayDateClassName, dateRangeDisplayStartDateClassName);
    const endDateClassName = classNames(dateRangeDisplayDateClassName, dateRangeDisplayEndDateClassName);

    const separatorClassName = classNames(dateRangeDisplaySeparatorClassName);

    const isFilled = hasFilledDates(startDate, endDate);

    const isStartActive = !isFilled && !isSelecting;
    const isEndActive = !isFilled && isSelecting;

    const result = {
        className,
        startDateClassName,
        separatorClassName,
        endDateClassName,
        locale,
        startLabel,
        endLabel,
        startDate,
        endDate,
        dateFormatOptions,
        isStartActive,
        isEndActive
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
